type EmergencyContactData = {
    contactname: string;
    contactnumber: string;
    contactrelation: string;
    contactaddress?: string;
}

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * patient Emergency Contact Component
 * @param response  has the backend emergency contact response
 * @param context has settings etc..
 */
export const TransformResponse = (response: any, context: any) => {
    const { log } = context;
    /**
     * @param result contains the transformed response
     */
    let edata: EmergencyContactData[] = [];

    let result :any = {
        edata: edata,
        error: undefined
    }
    
    console.log("response_emergencycontact", response);
    
    if (response && (response.status >= 400 || response.type == "error")) {
       result.error = response;
       result.edata = []; // Ensure edata is always an array
    }
    // Case 1: API may return an array (e.g., via proxy) of person objects
    else if (Array.isArray(response) && response.length > 0) {
        response.forEach((r: any) => {
            const names: string[] = [];
            if (r.firstName) names.push(r.firstName);
            if (r.middleName) names.push(r.middleName);
            if (r.lastName) names.push(r.lastName);
            const contactname = (r.name || names.join(' ')).trim();

            const contactrelation = r.relationship || r.relation || "";

               let contactnumber = r.cellPhone
                    || r.homePhone
                    || r.dayPhone
                    || r.alternatePhone
                    || r.secondaryHomePhone
                    || r.internationalHomePhone
                    || r.phone
                    || '';


            edata.push({
                contactname,
                contactnumber: contactnumber || "",
                contactrelation,
            });
        });
    }
    // Case 2: NextGen API returns { success, results: { ...person fields... } }
    else if (response && (response.results || response.success !== undefined)) {
        const r = response?.results || {};
        const names: string[] = [];
        if (r.firstName) names.push(r.firstName);
        if (r.middleName) names.push(r.middleName);
        if (r.lastName) names.push(r.lastName);
        const contactname = names.join(' ').trim();

        const contactrelation = r.relationship || "";
 
            let contactnumber = r.cellPhone
                || r.homePhone
                || r.dayPhone
                || r.alternatePhone
                || r.secondaryHomePhone
                || r.internationalHomePhone
                || '';
        

        edata.push({
            contactname,
            contactnumber: contactnumber || "",
            contactrelation
        });
    }
    // Case 3: Some environments return the person object directly (no wrapper)
    else if (response && (response.firstName || response.lastName)) {
        const r: any = response;
        const names: string[] = [];
        if (r.firstName) names.push(r.firstName);
        if (r.middleName) names.push(r.middleName);
        if (r.lastName) names.push(r.lastName);
        const contactname = names.join(' ').trim();

        const contactrelation = r.relationship || "";


            let contactnumber = r.cellPhone
                || r.homePhone
                || r.dayPhone
                || r.alternatePhone
                || r.secondaryHomePhone
                || r.internationalHomePhone
                || '';

        edata.push({
            contactname,
            contactnumber: contactnumber || "",
            contactrelation
        });
    }
    
    // Ensure edata is always an array, even if empty
    result.edata = edata || [];
    
    log.debug(
        "ccw-gadget,emergencycontact-cerner",
        "emergencycontact-cerner transformation response ", {
        edata: result.edata
    });
    
    return result;
} 